<template>
  <div class="page__wrapper">
    <header class="page__header">
      <p class="sub-title">
        The cookie policy of Klevaar outlines the different types of cookies that may be used in
        relation to the Website <a href="https://klevaar.com">http://klevaar.com</a> owned and
        administered by us, through which you have access to this Cookie Policy (the "Website"), as
        well as information on how you can control them.
      </p>
    </header>
    <section class="page__content">
      <div class="page__content--item">
        <h2 class="page__content--item-title">What are actually cookies?</h2>
        <p class="description">
          Cookies are small files, which are used for access to the Internet, that are stored on the
          computer, the mobile device, the tablet or other equipment of a given User.
        </p>
        <p class="description">
          Cookies are installed through a request by the server of a given web page to your web
          browser (i.e. Internet Explorer, Chrome, Safari, Mozilla) and are completely "passive"
          (they do not contain any software, viruses or spyware and do not have access to the
          information of the User hardware).
        </p>
      </div>
      <div class="page__content--item">
        <h2 class="page__content--item-title">What are cookies used for?</h2>
        <p class="description">
          Cookies are used in a way, allowing the Website to function better and more efficiently.
          Cookies are needed in order for you to browse the Website and to use their services and
          functionalities. Without those essential cookies, our Website will not function as
          fluently as we would like them to and we might not be able to provide you with certain
          services or features.
        </p>
        <p class="description">
          Cookies are also used in order to prepare anonymous statistics, which aid us at
          understanding, how a given user prefers to use our Website, allowing us to improve its
          structure and contents, without identifying the user. The Klevaar Website may also use
          certain Wordpress features, software such as Google Analytics, Google Adsense or Google
          Adwords, Facebook, Twitter, Google+ or other social media “like” buttons or plugins, which
          contain cookies.
        </p>
      </div>
      <div class="page__content--item">
        <h2 class="page__content--item-title">What types of cookies do we use?</h2>
        <p class="description">
          We use two types of cookies – for the user session and fixed ones. The former ones are
          temporary files, which remain on the device of the User until the end of his/her user
          session or until closing the web browser. The fixed files remain on the device of the User
          for the period, specified in the cookies themselves or until deleted by the User.
        </p>
        <p class="description">What are the purposes for which we use cookies?</p>
        <ul class="cookies--purposes">
          <li class="purpose">
            <span>Processes</span>
            <p>
              Intended to make the Website work in the way you expect. For example, we use a cookie
              that tells us whether you have already signed up for a User Account.
            </p>
          </li>
          <li class="purpose">
            <span>Authentication, Security and Compliance</span>
            <p>
              Intended to prevent fraud, protect your data from unauthorized parties, and comply
              with legal requirements. For example, we use cookies to determine if you are logged in
              your User Account.
            </p>
          </li>
          <li class="purpose">
            <span>Preferences</span>
            <p>
              Intended to remember information about how you prefer the services to behave and look.
              For example, we use a cookie that tells us whether you have declined to allow us to
              use your phone’s geolocation data.
            </p>
          </li>
          <li class="purpose">
            <span>Notifications</span>
            <p>
              Intended to allow or prevent notices of information or options that we think could
              improve your use of the Service. For example, we use a Cookie that stops us from
              showing you the signup notification if you have already seen it.
            </p>
          </li>
          <li class="purpose">
            <span>Analytics</span>
            <p>
              Intended to help us understand how visitors use the services. For example, we use a
              Cookie that tells us how our search suggestions correlate with your interactions with
              the search page.
            </p>
          </li>
        </ul>
      </div>
      <div class="page__content--item">
        <h2 class="page__content--item-title">Do cookies contain personal data?</h2>
        <p class="description">
          On their own, cookies do not require personal information in order to be used and most
          often, they do not identify internet Users. The personal data collected during the usage
          of cookies can only be gathered in order to ease the use of the services by the User. This
          data is encrypted in such a way that it does not allow unauthorized persons to gain access
          to it.
        </p>
      </div>
      <div class="page__content--item">
        <h2 class="page__content--item-title">Deleting the cookies</h2>
        <p class="description">
          In general, applications for access to web pages (web- or mobile browsers) allow the
          storage of cookies by default. These settings may be changed in such a way that the
          automatic administration of cookies is blocked by the web browser or that the User would
          be informed each time when cookies are sent to his/her device. Detailed information about
          the options and management of cookies may be found in the settings of the Web Browser.
          Limiting the usage of cookies may affect some of the features of the Website.
        </p>
      </div>
      <div class="page__content--item">
        <h2 class="page__content--item-title">Security and confidentiality</h2>
        <p class="description">
          Cookies are NOT viruses. They take the form of simple text. They are not made out of code
          and cannot therefore be executed or execute themselves alone. Consequently, they may not
          be duplicated or copied into other networks in order to get started and copied once more.
          Since cookies cannot perform those functions, they cannot be regarded as viruses.
        </p>
        <p class="description">
          Most often, browsers have built-in privacy settings, which provide different levels for
          the acceptance of cookies, the period of their validity and their automatic deletion after
          a User has visited a given website.
        </p>
      </div>
      <div class="page__content--item">
        <h2 class="page__content--item-title">
          Advice on secure and responsible surfing, using cookies
        </h2>
        <p class="description">
          Thanks to their flexibility and the fact that many of the most visited and biggest
          websites use cookies, their use is almost inevitable. Deactivating cookies will not allow
          the access of a given user to many of the most commonly used websites, including YouTube,
          Yahoo, Gmail and others.˝
        </p>
        <p class="description">
          Most often, browsers have built-in privacy settings, which provide different levels for
          the acceptance of cookies, the period of their validity and their automatic deletion after
          a User has visited a given website.
        </p>
        <p class="description">
          Here is some advice, which can ensure safe surfing, but with the help of cookies:
        </p>
        <ol>
          <li>
            Personalize your cookie browser settings, in order to create an adequate level of
            protection from the use of cookies.
          </li>
          <li>
            If you are the only person who uses the computer, you may set longer terms for
            expiration of the storage of the browsing history and access to personal data.
          </li>
          <li>
            If you share your computer access with somebody, you may set your browser settings to
            delete the surfing data every time you close your web browser.
          </li>
          <li>
            Ensure that your browser is always up to date. Many of the attacks, based on cookies,
            are realized when exploiting the weak spots of old and non-updated versions of the web
            browsers. Cookies are everywhere and they may not be circumvented if you would like to
            enjoy your access to the best and biggest websites on the Internet.
          </li>
        </ol>
        <p class="description">
          It is possible that you set your browser in a way that does not allow for cookies to be
          accepted anymore or you can set your browser to accept cookies only from certain websites.
          All modern browsers offer the option to change cookie settings. This includes computer
          browsers, as well as mobile device browsers. These settings can be found in the "options"
          menu or the "preferences" menu of your browser. In order to find those settings, you can
          also use the links below or use the "help" menu of your browser for more information.
        </p>
        <ul class="more--info-links">
          <li><a href="">Cookie settings in Internet Explorer</a></li>
          <li><a href="">Cookie settings in Firefox</a></li>
          <li><a href="">Cookie settings in Chrome</a></li>
          <li><a href="">Cookie settings in Safari</a></li>
        </ul>
        <p class="description">
          For setting third party cookies, you may use the following website:
        </p>
        <p class="description">
          <a href="http://www.youronlinechoices.com">http://www.youronlinechoices.com</a>
        </p>
      </div>
      <div class="page__content--item">
        <h2 class="page__content--item-title">Useful links</h2>
        <p class="description">
          If you want to find out more about cookies and what are they used for, we recommend you
          the following links:
        </p>
        <p class="description link">
          <a href="">Microsoft Cookies guide</a>
        </p>
        <p class="description link">
          <a href="">All About Cookies</a>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CookiePolicy',
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  .page__header {
    margin-bottom: 2rem;

    .sub-title {
      font-weight: 400;
      font-size: 1.4rem;
      line-height: 150%;
      letter-spacing: -0.02rem;
      color: $black;

      a {
        color: $primary-purple;
      }
    }
  }

  .link {
    text-decoration: underline;
  }

  .page__content {
    &--item {
      margin-top: 2rem;

      &-title {
        font-weight: 700;
        font-size: 1.4rem;
        line-height: 150%;
        letter-spacing: -0.02rem;
        color: $black;
      }

      .description {
        font-weight: 400;
        font-size: 1.4rem;
        line-height: 150%;
        letter-spacing: -0.02rem;
        color: $black;
        margin: 2rem 0 0 0;
      }
    }
  }

  .cookies--purposes {
    .purpose {
      list-style-type: none;
      font-size: 1.6rem;
      line-height: 150%;
      letter-spacing: -0.02rem;
      color: #000000;
      display: grid;
      grid-template-columns: 20rem minmax(auto, 46.6rem);
      grid-gap: 3.6rem;

      span {
        font-weight: 700;
      }

      p {
        font-weight: 500;
      }
    }
  }

  .more--info-links {
    padding-left: 2rem;

    li {
      text-decoration: underline;
    }
  }

  @media screen and (max-width: 768px) {
    .cookies--purposes {
      .purpose {
        grid-template-columns: 1fr;
        grid-gap: 0;
        margin: 2rem 0 1.6rem 0;
        font-size: 1.4rem;

        span {}

        p {
          font-weight: 400;
        }
      }
    }
  }
}
</style>
